function generateRandomID() {
  let result = '';
  const length = 4;
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function generateNumberArray(start, end) {
  if (typeof start !== 'number' || typeof end !== 'number') {
    throw new TypeError('Both start and end must be numbers');
  }
  if (start > end) {
    throw new RangeError('Start must be less than or equal to end');
  }
  const result = [];
  for (let number = start; number <= end; number++) {
    result.push(number);
  }
  return result;
}

export { generateRandomID, generateNumberArray };
